import React, { memo } from 'react';
import { createUseStyles, clsx } from '@pushpay/styles';
import { Box } from './box';
import { MainProvider } from './main-context';
const useStyles = createUseStyles({
  root: {
    display: 'block' // IE 11 doesn't recognize <main> so we need to force it to block

  }
});
export const Main = /*#__PURE__*/memo(({
  mobileWhen,
  space,
  spaceH,
  spaceV,
  classes: classesProp,
  className: classNameProp,
  children,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const className = clsx(classNameProp, classes.root);
  const spaceProps = space ? {
    space
  } : {
    spaceH,
    spaceV
  };
  return /*#__PURE__*/React.createElement(MainProvider, Object.assign({
    mobileWhen: mobileWhen
  }, spaceProps), /*#__PURE__*/React.createElement(Box, Object.assign({
    component: "main",
    role: "main",
    className: className
  }, spaceProps, rest), children));
});